import React, {useContext} from "react";
import cx from 'classnames';
import { Link as ScrollLink } from 'react-scroll';
import Link  from 'next/link'
import {ArrowRightOutlined, ArrowDownOutlined} from "@ant-design/icons";
import {Space} from "antd";
import {TExamDetailFixedDataType} from "@/types";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import Fcrpd from "@/page-components/detail/Plan/fcrpd";
import {DetailContext} from "@/context/detailContext";
import {PayState} from "@/page-components/detail/Intro/exam_plan";
import styles from './styles.module.less';

type TData = {
  data:TExamDetailFixedDataType
}

const Plan:React.FC<TData> = () => {
  const contextProps = useContext(DetailContext);
  const {signupInfo, data} = contextProps;
  const createPlanCom = () => {
    return (
      <>
        {data && (
          <>
            <h1 className={styles.title}>考试安排</h1>
            {
              data.type === 'fcrpd' ? <Fcrpd /> : (
                <div className={styles.exam_plan_body}>
                  <ScrollLink to="anchor1" smooth duration={500}>
                    <div className={styles.exam_item_wrapper}>
                      <div className={cx(styles.subtitle,styles.subtitle_wrapper)}>通过考试</div>
                      <Space className={styles.exam_item} size={16}>
                        <img src="/img/detail/exam_plan1.png" className={styles.exam_item_icon} alt="" />
                        <div>
                          <p className={styles.exam_item_title}>{data.short_cn_title}考试</p>
                          <Space className={styles.exam_item_row} size={6}>
                            <span className={styles.exam_item_price}>{data.exam_info.exam_money ===0 ? '免费' : `￥${data.exam_info.exam_money}`}</span>
                            <span>{data.exam_info.pass_condition}</span>
                          </Space>
                        </div>
                      </Space>
                    </div>
                  </ScrollLink>
                  <MobileComponentWrapper>
                    <ArrowDownOutlined className={styles.arrow_icon}/>
                  </MobileComponentWrapper>
                  <PcComponentWrapper>
                    <ArrowRightOutlined className={styles.arrow_icon}/>
                  </PcComponentWrapper>
                  <a target="_blank" href="/verify" className={styles.exam_item_wrapper}>
                    <div className={cx(styles.subtitle,styles.subtitle_wrapper)}>获得证书</div>
                    <Space className={styles.exam_item} size={16}>
                      <img src="/img/detail/exam_plan2.png" className={styles.exam_item_icon} alt="" />
                      <div>
                        <p className={styles.exam_item_title}>{data.certificate_title}</p>
                        <Space className={styles.exam_item_row} size={10}>
                          <span className={styles.exam_item_price}>{data.isProfession ? '资深认证' : '入门认证' }</span>
                        </Space>
                      </div>
                    </Space>
                  </a>
                </div>
              )
            }
          </>
        )}
      </>
    )
  }
  const isRenderCom = () => {
    console.log('isRenderCom');
    console.log(signupInfo);
    // 报名信息为空或者报名信息里有未付款
    if (signupInfo && Array.isArray(signupInfo) && signupInfo.length !== 0) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < signupInfo.length; i++) {
        const signupInfoItem = signupInfo[i];
        if (signupInfoItem.payState === undefined) {
          return false
        }
        return (signupInfoItem.payState === PayState.payed);
      }
    }
    return false;
  }
  return (
    <div className={styles.exam_plan_wrapper}>
      {createPlanCom()}
      {/*{isRenderCom() ? createPlanCom() : (*/}
      {/*  <PCSignupBtn*/}
      {/*    payState={signupInfo.length >0?signupInfo[0].payState : undefined}*/}
      {/*  >*/}
      {/*    {createPlanCom()}*/}
      {/*  </PCSignupBtn>*/}
      {/*)}*/}
    </div>
  )
}
export default Plan;
